import { NavItem } from '../full/vertical/sidebar/nav-item/nav-item';
import { pharmacyMenuGroups } from './pharmacy.menu';
import { warehouseCompras } from './warehouse.menu';

// ============================================================================
//  Menú del rol Administrator — organizado por secciones de área de negocio.
//
//  El Administrator ve todos los módulos por ahora; cuando existan más roles
//  (cajero, compras, enfermería, etc.) cada sección/bloque se asignará al rol
//  correspondiente en lugar de duplicar items.
//
//  Máximo 2 niveles (grupo → item) para compatibilidad con el layout horizontal.
// ============================================================================

export const navItemsAdministrativeDirection: NavItem[] = [
  // ── Inicio ──────────────────────────────────────────────────────────────
  {
    navCap: 'Inicio',
  },
  {
    displayName: 'Escritorio',
    iconName: 'home',
    route: '/administracion',
  },

  // ── Farmacia (POS) ──────────────────────────────────────────────────────
  {
    navCap: 'Farmacia (POS)',
  },
  ...pharmacyMenuGroups,

  // ── Almacén ─────────────────────────────────────────────────────────────
  {
    navCap: 'Almacén',
  },
  warehouseCompras,

  // ── Hospital ────────────────────────────────────────────────────────────
  {
    navCap: 'Hospital',
  },
  {
    displayName: 'Consultorios',
    iconName: 'stethoscope',
    route: '/administracion/consultas-externas',
  },
  {
    displayName: 'Hospitalización',
    iconName: 'bed',
    route: 'hospitalizacion',
    children: [
      { displayName: 'Lista de hospitalizaciones', iconName: 'point', route: '/administracion/hospitalizaciones' },
      { displayName: 'Historial de hospitalizaciones', iconName: 'point', route: '/administracion/historial-hospitalizaciones' },
      { displayName: 'Registrar hospitalización', iconName: 'point', route: '/administracion/registrar-hospitalizacion' },
    ],
  },
  {
    displayName: 'Pagos de consultas',
    iconName: 'coin',
    route: '/administracion/pago-consultas-atencion-interna',
  },

  // ── Catálogos ───────────────────────────────────────────────────────────
  {
    navCap: 'Catálogos',
  },
  {
    displayName: 'Medicamentos',
    iconName: 'pill',
    route: 'medicamentos',
    children: [
      { displayName: 'Inventario (todas las bodegas)', iconName: 'point', route: '/inventario/productos' },
      { displayName: 'Ingredientes activos', iconName: 'point', route: '/active-ingredients' },
    ],
  },
  {
    displayName: 'Personal',
    iconName: 'users',
    route: 'personal',
    children: [
      { displayName: 'Doctores', iconName: 'point', route: '/administracion/doctores' },
      { displayName: 'Enfermeros', iconName: 'point', route: '/administracion/enfermeros' },
    ],
  },
  {
    displayName: 'Proveedores',
    iconName: 'truck',
    route: '/administracion/proveedores',
  },

  // ── Sistema ─────────────────────────────────────────────────────────────
  {
    navCap: 'Sistema',
  },
  {
    displayName: 'Usuarios',
    iconName: 'user-cog',
    route: '/administracion/usuarios',
  },
  {
    displayName: 'Roles y permisos',
    iconName: 'shield-lock',
    route: '/apps/roles-permissions',
  },
  {
    displayName: 'Estudios de laboratorio',
    iconName: 'flask',
    route: '/administracion/estudios-laboratorio',
  },
];
